import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

const module = angular.module('contact-us', []);

module.component('contactUs', {
    template: template,
    controller: function(this: angular.IComponentController) {
        this.$onInit = () => {
            this.showDetails = false;
        };

        this.contactUs = () => {
            this.showDetails = !this.showDetails;
        };
    }
});

export { module };
